import { boot } from "quasar/wrappers";
import { feedbackWidget } from "src/services/feedback";
import { isConfigValid } from "src/services/feedback/config";

export default boot(({ app, store }) => {
  // Register the capture directives unconditionally so templates that use them
  // (PR 2 redaction pass) never break when the widget is off. They only add our
  // neutral marker classes; they carry no styles.
  const { mask, block } = feedbackWidget.getMaskClasses();
  app.directive("capture-mask", {
    mounted(el) {
      mask.forEach((c) => el.classList.add(c));
    },
  });
  app.directive("capture-block", {
    mounted(el) {
      block.forEach((c) => el.classList.add(c));
    },
  });

  // Kill switch: nothing else runs unless enabled + provider + token are all set.
  if (!isConfigValid()) return;

  // This boot file runs after src/boot/auth.js has awaited checkAuth, so the auth
  // state is authoritative at load.
  if (store.state.auth.is_user_logged_in) {
    feedbackWidget.init(store.state.auth.user);
  }

  // Cover SPA login/logout. Logout is SPA (no reload) so teardown is load-bearing;
  // login triggers a full reload, so the init branch is a harmless fallback.
  store.watch(
    (s) => s.auth.is_user_logged_in,
    (loggedIn) => {
      if (loggedIn) feedbackWidget.init(store.state.auth.user);
      else feedbackWidget.teardown();
    }
  );
});
